import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState.ts';
import {
  handleFetchTasksAdministrationRolesFulfilled,
  handleFetchTasksAdministrationRolesPending,
  handleFetchTasksAdministrationRolesRejected,
  handleFetchTasksAdministrationTasksFulfilled,
  handleFetchTasksAdministrationTasksPending,
  handleFetchTasksAdministrationTasksRejected,
  handleFetchTasksSupervisorsFulfilled,
  handleFetchTasksSupervisorsPending,
  handleFetchTasksSupervisorsRejected,
  handleFetchTasksUakdoAccessFulfilled,
  handleFetchTasksUakdoAccessPending,
  handleFetchTasksUakdoAccessRejected,
  handleTasksPatchAssigneeFulfilled,
  handleTasksPatchAssigneePending,
  handleTasksPatchAssigneeRejected,
  handleTasksUpdateStatusFulfilled,
  handleTasksUpdateStatusPending,
  handleTasksUpdateStatusRejected,
} from './reducers.ts';
import {
  fetchTasksAdministrationRoles,
  fetchTasksAdministrationTasks,
  fetchTasksSupervisors,
  fetchTasksUakdoAccess,
  patchTasksAssignee,
  updateTasksApplicationStatus,
  updateTasksUdbtfStatus,
  updateTasksUmvnStatus,
  updateTasksUoStatus,
} from './thunks/tasksThunks.ts';

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTasksAdministrationRoles.pending, handleFetchTasksAdministrationRolesPending)
      .addCase(fetchTasksAdministrationRoles.fulfilled, (state, { payload }) =>
        handleFetchTasksAdministrationRolesFulfilled(state, payload)
      )
      .addCase(fetchTasksAdministrationRoles.rejected, (state, { payload }) =>
        handleFetchTasksAdministrationRolesRejected(state, payload)
      )
      .addCase(fetchTasksAdministrationTasks.pending, handleFetchTasksAdministrationTasksPending)
      .addCase(fetchTasksAdministrationTasks.fulfilled, (state, { payload }) =>
        handleFetchTasksAdministrationTasksFulfilled(state, payload)
      )
      .addCase(fetchTasksAdministrationTasks.rejected, (state, { payload }) =>
        handleFetchTasksAdministrationTasksRejected(state, payload)
      )
      .addCase(fetchTasksUakdoAccess.pending, handleFetchTasksUakdoAccessPending)
      .addCase(fetchTasksUakdoAccess.fulfilled, (state, { payload }) =>
        handleFetchTasksUakdoAccessFulfilled(state, payload)
      )
      .addCase(fetchTasksUakdoAccess.rejected, (state, { payload }) =>
        handleFetchTasksUakdoAccessRejected(state, payload)
      )
      .addCase(fetchTasksSupervisors.pending, handleFetchTasksSupervisorsPending)
      .addCase(fetchTasksSupervisors.fulfilled, (state, { payload }) =>
        handleFetchTasksSupervisorsFulfilled(state, payload)
      )
      .addCase(fetchTasksSupervisors.rejected, (state, { payload }) =>
        handleFetchTasksSupervisorsRejected(state, payload)
      )
      .addCase(patchTasksAssignee.pending, handleTasksPatchAssigneePending)
      .addCase(patchTasksAssignee.fulfilled, (state, { payload }) =>
        handleTasksPatchAssigneeFulfilled(state, payload)
      )
      .addCase(patchTasksAssignee.rejected, (state, { payload }) =>
        handleTasksPatchAssigneeRejected(state, payload)
      );

    [
      updateTasksUdbtfStatus,
      updateTasksUoStatus,
      updateTasksUmvnStatus,
      updateTasksApplicationStatus,
    ].forEach((thunk) => {
      builder
        .addCase(thunk.pending, handleTasksUpdateStatusPending)
        .addCase(thunk.fulfilled, (state, { payload }) =>
          handleTasksUpdateStatusFulfilled(state, payload)
        )
        .addCase(thunk.rejected, (state, { payload }) =>
          handleTasksUpdateStatusRejected(state, payload)
        );
    });
  },
});

export default tasksSlice.reducer;
